//@ts-ignore
import { tw } from '@careinfo/tailwind';
const TextAreaInput = (props: any) => {
  const {
    placeholder,
    value,
    onChange,
    register,
    row = 4,
    errors,
    label,
    disabled = false,
  } = props;

  return (
    <div className={tw`w-full text-left mt-2`}>
      {/* <label htmlFor="" className={tw `my-auto font-semibold flex items-center text-lg`}>{label}</label> */}
      <label htmlFor=''>{label}</label>
      <textarea
        placeholder={placeholder}
        maxLength={150}
        rows={row}
        disabled={disabled}
        autoComplete='off'
        value={value}
        onChange={onChange}
        {...register}
        className={tw`w-full focus:outline-none bg-[#EEF5F4] p-2 mt-1`}
      />
      {errors && (
        <p className={tw`text-red-500 text-xs my-1`}>{errors?.message}</p>
      )}
    </div>
  );
};

export default TextAreaInput;
